<mat-card class="manager-card">
    <mat-card-header>
      <mat-card-title>Manager Dashboard</mat-card-title>
    </mat-card-header>
    <br>
    <mat-card-content>
      <div class="section" (click)="openManagerSettings()" id="feeder-manager">
        <h2>Feeder Manager</h2>
      </div>
      <div class="section" (click)="openSiteManager()" id="site-manager">
        <h2>Site Manager</h2>
        <!-- Site Manager content goes here -->
      </div>
      <div class="section" (click)="openUserMaintainance()" id="user-maintenance">
        <h2>User Maintenance</h2>
        <!-- User Maintenance content goes here -->
      </div>
    </mat-card-content>
  </mat-card>
  